import React from "react";

/**
 * アセットカルーセル共通カードの幅・高さ（動画以外）
 * resol_metis（チャットウィジェット本体）の ASSET_CARD_WIDTH と揃えている
 */
export const ASSET_CARD_WIDTH = 190;
export const ASSET_CARD_IMAGE_HEIGHT = 142;

/**
 * アセットカード（画像/PDF/ファイル共通UI）
 * 画像（or サムネイル/バッジ）+ アセットタイトル + アセット詳細説明 + 右下`›`ボタン
 * fullWidth: アセットが1枚のみの場合、カルーセル幅いっぱいに表示する
 */
export default function AssetCard({
  thumbnailUrl,
  fallback,
  title,
  description,
  onButtonClick,
  alt,
  fullWidth,
}: {
  thumbnailUrl?: string;
  fallback?: React.ReactNode;
  title?: string;
  description?: string;
  onButtonClick: () => void;
  alt?: string;
  fullWidth?: boolean;
}) {
  const imageHeight = fullWidth ? 220 : ASSET_CARD_IMAGE_HEIGHT;
  return (
    <div
      style={{
        flexShrink: fullWidth ? 1 : 0,
        flexGrow: fullWidth ? 1 : 0,
        width: fullWidth ? "100%" : `${ASSET_CARD_WIDTH}px`,
        borderRadius: "12px",
        overflow: "hidden",
        background: "transparent",
        border: "1px solid #eee",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: `${imageHeight}px`,
          background: "#f0f0f0",
        }}
      >
        {thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt={alt || title || ""}
            loading="lazy"
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {fallback}
          </div>
        )}
        <button
          type="button"
          onClick={onButtonClick}
          aria-label="詳細"
          style={{
            position: "absolute",
            right: "8px",
            bottom: "8px",
            width: fullWidth ? "32px" : "28px",
            height: fullWidth ? "32px" : "28px",
            borderRadius: "9999px",
            background: "rgba(255, 255, 255, 0.92)",
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <svg width={fullWidth ? "18" : "16"} height={fullWidth ? "18" : "16"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18l6-6-6-6" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      {(title || description) && (
        <div style={{ padding: fullWidth ? "13px 14px 13px" : "10px 10px 10px", backgroundColor: "#fff" }}>
          {title && (
            <div
              style={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#111",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </div>
          )}
          {description && (
            <div
              style={{
                fontSize: fullWidth ? "13px" : "11px",
                lineHeight: 1.4,
                color: "#666",
                marginTop: title ? "2px" : 0,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              } as React.CSSProperties}
            >
              {description}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
